import historyTemplate from './history.html';

export default angular
  .module('main.reports.view.tabs.history', [])

  .directive('reportViewHistoryTab', () => {
    return {
      restrict: 'E',
      template: historyTemplate,
      scope: {},
      controller: ($scope,
                   $filter,
                   ToastsService,
                   ViewReportDataProvider) => {

        const $t = $filter('translate');

        const dataProvider = ViewReportDataProvider.instance;
        $scope.dataProvider = dataProvider;

        const isGlobalReport = dataProvider.isGlobalReport;

        $scope.report = angular.copy(dataProvider.reportResource.value);
        $scope.orgInfo = dataProvider.orgInfo;
        $scope.historyLoading = false;
        $scope.defaultDates = true;
        $scope.filterDate = null;
        $scope.timezone = moment.tz.guess() || 'GMT';
        $scope.timeFormatStr = $t('reports.view.history.timestamp');
        $scope.datePickerDateTimeFormat = $t('datetime.measurements.datePickerMonth');

        $scope.datePickerOptions = {
          position: 'bottom left',
          autoClose: true,
          view: 'months',
          minView: 'months',
          dateFormat: $scope.datePickerDateTimeFormat,
          maxDate: new Date(),
          timepicker: false,
          clearButton: true,
        };

        angular.extend($scope, {
          downloadData: downloadData,
          getExecutionOrgName: getExecutionOrgName,
          getExecutionTime: getExecutionTime,
          executionColor: executionColor,
          back: () => dataProvider.goBack(),
        });

        init();

        function init() {
          dataProvider.availableOrganizationsResource.init();

          $scope.$watch('filterDate', (newVal, oldVal) => {
            if (newVal === oldVal) {
              return;
            }

            $scope.defaultDates = !newVal;
            getReportExecutionData();
          });

          // Reload executions in the background when a report finishes generating,
          // so the freshly generated execution appears in the list.
          $scope.$watch(() => dataProvider.isGeneratingReport, (isGenerating, wasGenerating) => {
            if (wasGenerating && !isGenerating) {
              getReportExecutionData(true);
            }
          });

          getReportExecutionData();
        }

        /**
         * Get report execution data.
         * @param {boolean} silent If true, don't show loading spinner
         */
        function getReportExecutionData(silent) {
          if (!silent) {
            $scope.historyLoading = true;
          }

          let startDate;
          let endDate;

          if ($scope.filterDate) {
            startDate = moment($scope.filterDate).clone()
              .startOf('month')
              .valueOf();
            endDate = moment(startDate)
              .endOf('month')
              .add(1, 'ms')
              .valueOf();
          } else {
            // Get data for last 14 days
            let nowMoment = moment().tz($scope.timezone);
            let dateInPast = nowMoment.clone();
            startDate = dateInPast.clone()
              .subtract(14, 'd')
              .startOf('d')
              .valueOf();
            endDate = dateInPast.valueOf();
          }

          return dataProvider.getReportExecutions({
            reportId: $scope.report.id,
            reportGroupId: $scope.report.reportGroups[0].id,
            organizationId: !isGlobalReport ? $scope.orgInfo?.id : void 0,
            startDate: startDate,
            endDate: endDate
          })
            .then(data => {
              let executions = angular.copy(data?.executions || []);
              $scope.dataHistory = executions.filter(el => !!el.url);
              $scope.historyLoading = false;
            }, (err) => {
              $scope.historyLoading = false;
            });
        }

        /**
         * Download file
         */
        function downloadData(data) {
          return dataProvider.downloadData(data)
            .then(() => {
              // Success
            }, (err) => {
              console.warn(err);
              ToastsService.error(null, $t('reports.view.history.downloadError'));
            });
        }

        function getExecutionOrgName(execution) {
          if (isGlobalReport) {
            return $t('reports.view.history.allOrganizations');
          }
          if (!execution || !execution.organizationId) {
            return $t('main.common.unknownOrganization');
          }

          let availableOrgs = dataProvider.availableOrganizationsResource.value || [];
          let org = availableOrgs.find(org => org.id === execution.organizationId);
          return org ? org.name : $t('main.common.unknownOrganization');
        }

        /**
         * Show color for the execution row:
         * - "green" (true) if the execution belongs to the current organization or if it's a global report
         * - "orange" (false) if the execution belongs to sub-organization
         * @param {Object} execution
         * @return {boolean}
         */
        function executionColor(execution) {
          if (isGlobalReport) {
            return true;
          }
          return !!(execution && $scope.orgInfo && execution.organizationId === $scope.orgInfo.id);
        }

        /**
         * Execution duration.
         * @param {Object} execution Execution with `executionTime` in seconds
         * @return {string}
         */
        function getExecutionTime(execution) {
          if (!execution || execution.executionTime == null) {
            return '';
          }

          const duration = moment.duration(execution.executionTime, 'seconds');
          if (duration.asSeconds() < 60) {
            return $t('reports.view.history.executionTime.seconds', { seconds: Math.round(duration.asSeconds()) });
          }

          return $t('reports.view.history.executionTime.minutes', { time: duration.format('m:ss') });
        }

      }
    };
  })
  .name;
